// Shared accessors for the loosely-typed player payload the SavedLists surfaces pass around
// (search results, selected chips) — the shape carries either `playerId`/`displayName` (our
// normalized form) or the raw `id`/`name` from the API, so both MultiPlayerSearch and
// AddPlayerToListModal read it through these rather than re-deriving the fallbacks.
export const getPlayerId = (player) => player?.playerId ?? player?.id;
export const getPlayerName = (player) => player?.displayName ?? player?.name ?? '';
